export const customerPaymentsQueryKeys = {
  all: ["customer-payments"] as const,
  list: (userId: string) =>
    [...customerPaymentsQueryKeys.all, "list", userId] as const,
};

export default customerPaymentsQueryKeys;
